module.exports = __webpack_public_path__ + "static/media/em-20.d392e894.png";